import { useEffect, useRef } from 'react';

const INACTIVITY_LIMIT = 15 * 60 * 1000;

export const useAutoLogout = (onLogout) => {
  const timerRef = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onLogout();
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    if (!localStorage.getItem('isLoggedIn')) return;

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    window.addEventListener('beforeunload', onLogout);

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
      window.removeEventListener('beforeunload', onLogout);
    };
  }, []);
};
